const baseurl={
	dev:'https://msg.yfcat.com/index',
	mock:'',
	pro:''
}
export default baseurl
	
